/**
 * Constantes d'équilibrage combat partagées (client + serveur).
 *
 * Kalos (gen 6) : pool sauvage réduit → PV sauvages réduits pour éviter un mur artificiel.
 * Shiny sauvage : jackpot or/XP volontaire ; cumul avec charmes / maître Pokédex à surveiller en prod.
 *
 * Or : échelle en millions max (offline 24 h endgame), pas en milliards.
 * Sanctuaire a sa propre base (découplée du coût bannière Paldea).
 */

/** Multiplicateur PV sauvages gen 6 uniquement (boss zone utilise une logique séparée). */
export const KALOS_WILD_GEN_MULT = 0.45;

/**
 * Facteur global or sauvage / boss zone / boss tour.
 * 0.2 = ÷5 vs courbe historique (confort mid-game après retours Discord).
 */
export const COMBAT_GOLD_REWARD_SCALE = 0.2;

/**
 * Or/kill sanctuaire @ rewardMult 1.
 * ~50k ≈ ~1,3× meilleur sauvage Paldea à SCALE 0.2 (~38k z20) — premium sans printer.
 */
export const BATTLE_TOWER_SANCTUARY_GOLD_BASE = 50_000;

/** Exposant de progression or par génération (sauvage / boss). */
export const WILD_GOLD_GEN_EXPONENT = 2.0;

/** Base or gen 1 (avant diffScale et COMBAT_GOLD_REWARD_SCALE). */
export const WILD_GOLD_BASE_GEN1 = 50;

/** Base or gen ≥ 2 : `WILD_GOLD_BASE_GEN2 * exponent^(gen-2)`. */
export const WILD_GOLD_BASE_GEN2 = 500;

/** Multiplicateur or combat sauvage chromatique. */
export const WILD_SHINY_GOLD_MULT = 50;

/** Multiplicateur XP combat sauvage chromatique (aligné useCombatLoop). */
export const WILD_SHINY_XP_MULT = 100;

/** Kills sauvages requis pour passer à l’étape suivante (frontière). */
export const FRONTIER_KILLS_PER_STAGE = 10;

/** Valeur max de `stageKills` (0 … KILLS_PER_STAGE - 1). */
export const FRONTIER_MAX_STAGE_KILLS = FRONTIER_KILLS_PER_STAGE - 1;
